import { forwardRef } from 'react'

import { cn } from '@utils/cn'

interface PageProps {
  children: React.ReactNode
  className?: string
}

export const Page = forwardRef<HTMLElement, PageProps>(
  ({ children, className }, ref) => {
    return (
      <main
        ref={ref}
        className={cn(
          'flex h-screen w-full flex-col overflow-y-auto',
          className
        )}
      >
        {children}
      </main>
    )
  }
)

Page.displayName = 'Page'
